// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet documenten-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfDocumentenDocumentenGetPolisvoorwaardenMaatschappij } from '../model/collectionResultOfDocumentenDocumentenGetPolisvoorwaardenMaatschappij';

import type { CollectionResultOfDocumentenDocumentenGetVerzekeringskaartenVerzekeringskaart } from '../model/collectionResultOfDocumentenDocumentenGetVerzekeringskaartenVerzekeringskaart';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Lijst met alle verzekeringskaarten van alle productmaatschappijen.
 */
export const maatschappijDocumentenGetVerzekeringskaarten = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfDocumentenDocumentenGetVerzekeringskaartenVerzekeringskaart>(
    { url: `/api/v1/documenten/maatschappijen/verzekeringskaarten`, method: 'GET', signal },
    options,
  );
};

export const getMaatschappijDocumentenGetVerzekeringskaartenQueryKey = () => {
  return ['api', 'v1', 'documenten', 'maatschappijen', 'verzekeringskaarten'] as const;
};

export const getMaatschappijDocumentenGetVerzekeringskaartenQueryOptions = <
  TData = Awaited<ReturnType<typeof maatschappijDocumentenGetVerzekeringskaarten>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof maatschappijDocumentenGetVerzekeringskaarten>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatschappijDocumentenGetVerzekeringskaartenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof maatschappijDocumentenGetVerzekeringskaarten>>
  > = ({ signal }) => maatschappijDocumentenGetVerzekeringskaarten(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof maatschappijDocumentenGetVerzekeringskaarten>>,
    TError,
    TData
  >;
};

export type MaatschappijDocumentenGetVerzekeringskaartenQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatschappijDocumentenGetVerzekeringskaarten>>
>;
export type MaatschappijDocumentenGetVerzekeringskaartenQueryError = ErrorType<unknown>;

/**
 * @summary Lijst met alle verzekeringskaarten van alle productmaatschappijen.
 */

export function useMaatschappijDocumentenGetVerzekeringskaarten<
  TData = Awaited<ReturnType<typeof maatschappijDocumentenGetVerzekeringskaarten>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatschappijDocumentenGetVerzekeringskaarten>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatschappijDocumentenGetVerzekeringskaartenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Lijst met alle polisvoorwaarden van alle maatschappijen
 */
export const maatschappijDocumentenGetPolisvoorwaarden = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfDocumentenDocumentenGetPolisvoorwaardenMaatschappij>(
    { url: `/api/v1/documenten/maatschappijen/polisvoorwaarden`, method: 'GET', signal },
    options,
  );
};

export const getMaatschappijDocumentenGetPolisvoorwaardenQueryKey = () => {
  return ['api', 'v1', 'documenten', 'maatschappijen', 'polisvoorwaarden'] as const;
};

export const getMaatschappijDocumentenGetPolisvoorwaardenQueryOptions = <
  TData = Awaited<ReturnType<typeof maatschappijDocumentenGetPolisvoorwaarden>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof maatschappijDocumentenGetPolisvoorwaarden>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatschappijDocumentenGetPolisvoorwaardenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof maatschappijDocumentenGetPolisvoorwaarden>>
  > = ({ signal }) => maatschappijDocumentenGetPolisvoorwaarden(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof maatschappijDocumentenGetPolisvoorwaarden>>,
    TError,
    TData
  >;
};

export type MaatschappijDocumentenGetPolisvoorwaardenQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatschappijDocumentenGetPolisvoorwaarden>>
>;
export type MaatschappijDocumentenGetPolisvoorwaardenQueryError = ErrorType<unknown>;

/**
 * @summary Lijst met alle polisvoorwaarden van alle maatschappijen
 */

export function useMaatschappijDocumentenGetPolisvoorwaarden<
  TData = Awaited<ReturnType<typeof maatschappijDocumentenGetPolisvoorwaarden>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatschappijDocumentenGetPolisvoorwaarden>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatschappijDocumentenGetPolisvoorwaardenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Haalt de inhoud van een voorwaardedocument op.
 */
export const maatschappijDocumentenGetVoorwaarde = (
  voorwaardeid: MaybeRef<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  voorwaardeid = unref(voorwaardeid);

  return customInstance<unknown>(
    { url: `/api/v1/documenten/maatschappijen/voorwaarden/${voorwaardeid}`, method: 'GET', signal },
    options,
  );
};

export const getMaatschappijDocumentenGetVoorwaardeQueryKey = (
  voorwaardeid: MaybeRef<number | undefined | null>,
) => {
  return ['api', 'v1', 'documenten', 'maatschappijen', 'voorwaarden', voorwaardeid] as const;
};

export const getMaatschappijDocumentenGetVoorwaardeQueryOptions = <
  TData = Awaited<ReturnType<typeof maatschappijDocumentenGetVoorwaarde>>,
  TError = ErrorType<
    MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  voorwaardeid: MaybeRef<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatschappijDocumentenGetVoorwaarde>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatschappijDocumentenGetVoorwaardeQueryKey(voorwaardeid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof maatschappijDocumentenGetVoorwaarde>>> = ({
    signal,
  }) => maatschappijDocumentenGetVoorwaarde(voorwaardeid, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(voorwaardeid) !== null && unref(voorwaardeid) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof maatschappijDocumentenGetVoorwaarde>>,
    TError,
    TData
  >;
};

export type MaatschappijDocumentenGetVoorwaardeQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatschappijDocumentenGetVoorwaarde>>
>;
export type MaatschappijDocumentenGetVoorwaardeQueryError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Haalt de inhoud van een voorwaardedocument op.
 */

export function useMaatschappijDocumentenGetVoorwaarde<
  TData = Awaited<ReturnType<typeof maatschappijDocumentenGetVoorwaarde>>,
  TError = ErrorType<
    MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  voorwaardeid: MaybeRef<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatschappijDocumentenGetVoorwaarde>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatschappijDocumentenGetVoorwaardeQueryOptions(voorwaardeid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
